<template >
<div>
  <v-row justify="space-between px-3">
    <span class="grey--text subtitle-1 font-weight-normal"><v-icon small color="#81DBF6">mdi-finance</v-icon> Dashboard</span>
    <v-menu open-on-hover offset-y>
      <template v-slot:activator="{ on, attrs }">
      <v-btn v-on="on" v-bind="attrs" text small class="ml-2">
        {{Currency[0].CurrencyName}}<v-icon color="#81DBF6" class="ml-1">mdi-chevron-down</v-icon>
      </v-btn>
      </template>
      <v-list dense>
      <v-list-item v-for="Currency in allCurrencies.filter(a => a.CheckerID != 0 && a.RejectionID == 0)" :key="Currency.CurrencyID" @click="mapCurrency(Currency); GetGraphs()">

      <v-list-item-title>
        {{ Currency.CurrencyName }}
      </v-list-item-title>

      </v-list-item>
      </v-list>
    </v-menu>
  </v-row>

  <v-row>
    <v-col cols="5">
      <v-card class="elevation-6" height="485">          
        <v-card-text class="text-center">
          <v-row justify="space-between px-4">
            <span class="text-right subtitle-1 font-weight-light mb-0">Assets Distribution</span>
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="#2A353D"
              :size="20"
            ></v-progress-circular>
            <v-icon v-else @click="GetGraphs()"> mdi-sync</v-icon>
          </v-row>
          <v-divider color="#81DBF6" class="my-1 mb-0"></v-divider>
        </v-card-text>

        <div class="text-center">
          <Doughnut
            :height="410"
            :chartData="{
              labels: AssetDistributionNames,
              datasets: [{
                data: AssetDistributionGraph,
                backgroundColor: ['#2A353D', '#5EBCE8', '#FFBD00', '#FF6F00', '#75BC6B'],
                hoverOffset: 4
              }]
            }"
            :options="{
              maintainAspectRatio: false, 
              responsive: true,
              cutoutPercentage: 65,
              legend: {
                position: 'bottom',
                align: 'center',
                labels: {
                  boxWidth: 30
                }
              },
            }"
          />
        </div>
      </v-card>
    </v-col>
    <v-col col="7">
      <v-card class="elevation-6" height="485">
        <v-card-text>
          <v-row justify="space-between px-4">
            <span class="text-right subtitle-1 font-weight-light mb-0">FUM Top 5</span>
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="#2A353D"
              :size="20"
            ></v-progress-circular>
            <v-icon v-else @click="GetGraphs()"> mdi-sync</v-icon>
          </v-row>
          <v-divider color="#81DBF6" class="my-1 mb-0"></v-divider>
        </v-card-text>

        <div class="text-center pl-3">
          <Bar
            :height="430"
            :chartData="{
              labels: [''],
              datasets: FUMTopFiveGraph
            }"
            :options="{
              maintainAspectRatio: false, 
              responsive: true,
              legend: {
                position: 'right',
                align: 'end',
                labels: {
                  boxWidth: 30,
                  boxHeight: 2
                }
              },
            }"
          />
        </div>
      </v-card>
    </v-col>
  </v-row>
  <v-row>
    <v-col>
      <v-card class="elevation-6 fluid">
        <v-card-text>
          <v-row justify="space-between px-4">
            <span class="text-right subtitle-1 font-weight-light mb-0">Yield Curve</span>
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="#2A353D"
              :size="20"
            ></v-progress-circular>
            <v-icon v-else @click="GetGraphs()"> mdi-sync</v-icon>
          </v-row>
          <v-divider color="#81DBF6" class="my-1 mb-0"></v-divider>
        </v-card-text>

        <v-row class="px-3">
          <v-col>
            <v-select
              hint="Pick upto 5 institutions"
              persistent-hint
              multiple chips
              dense deletable-chips
              v-model="Sellers"
              :items="allCounterparties.filter(a => a.IsSeller == true && a.CheckerID != 0 && a.RejectionID == 0)"
              item-text="CounterPartyName"
              item-value="CounterPartyID"
              placeholder="----"
              label="Financial Institutions"
              :rules="[() => Sellers.length <= 5 || 'You can only select a total of 5',]"
            ></v-select>
          </v-col>
        </v-row>

        <div class="text-center mx-3">
          <line-chart
            :height="430"
            :chartData="{
              labels: MMRatesLabels,
              datasets: MMRates
            }"
            :options="{
              maintainAspectRatio: false, 
              responsive: true,
              legend: {
                position: 'bottom',
                align: 'center',
                labels: {
                  boxWidth: 30
                }
              },
            }"
          />
        </div>
      </v-card>
    </v-col>
  </v-row>
  <v-row>
    <v-col>
      <v-card class="elevation-6" height="485">
        <v-card-text>
          <v-row justify="space-between px-4">
            <span class="text-right subtitle-1 font-weight-light mb-0">Funds Under Management Performance</span>
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="#2A353D"
              :size="20"
            ></v-progress-circular>
            <v-icon v-else @click="GetGraphs()"> mdi-sync</v-icon>
          </v-row>
          <v-divider color="#81DBF6" class="my-1 mb-0"></v-divider>
        </v-card-text>

        <div class="text-center px-3">
          <Bar
            :height="410"
            :chartData="{
              labels: AssetPerformanceNames,
              datasets: AssetPerformanceGraph
            }"
            :options="{
              maintainAspectRatio: false, 
              responsive: true,
              legend: {
                position: 'right',
                align: 'end',
                labels: {
                  boxWidth: 30,
                  boxHeight: 2
                }
              },
              scales: {
                yAxes: [
                  {
                    ticks: {
                      beginAtZero: true
                    },
                  }
                ]
              }
            }"
          />
        </div>
      </v-card>
    </v-col>
  </v-row>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import reportsService from '../services/reports.service';
import Doughnut from './Chart.Doughnut.vue';
import Bar from './Chart.Bar.vue';
import LineChart from './Chart.Line.vue';
// import UserService from '../services/user.service'

export default {
  components: { 
    Doughnut,
    Bar,
    LineChart,
  },

  data () {
    return {
      overlay: false,
      loading: false,
      message: '',
      CurrencyId: 0,
      Sellers: [],
      AssetDistributionNames: ['Cash', 'Equity', 'Bond', 'Property', 'MM'],
      AssetDistributionGraph: [0,0,0,0,0],
      AssetDistributionTotal: 0,
      AssetPerformanceNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      AssetPerformanceLabels: ['Monthly', 'Quaterly', 'HalfYearly', 'Annually', 'Cumulative'],
      backgroundColor: ['#2A353D', '#5EBCE8', '#FFBD00', '#FF6F00', '#75BC6B'],
      AssetPerformanceGraph: [
        [0,0,0,0,0,0,0,0,0,0,0,0],
        [0,0,0,0,0,0,0,0,0,0,0,0],
        [0,0,0,0,0,0,0,0,0,0,0,0],
        [0,0,0,0,0,0,0,0,0,0,0,0],
        [0,0,0,0,0,0,0,0,0,0,0,0]
      ],
      FUMTopFiveGraph: [],
      MMRates: [],
      MMRatesLabels: ['1 Day', '7 Days', '14 Days', '21 Days', '30 Days', '60 Days', '90 Days', '120 Days', '180 Days', '270 Days', '365 Days', 'Over 365 Days'],
      value: null,
      value_1: null,
      value_2: [0, 200, 500, 900, 500, 1000, 300, 500, 100, 100, 100, 800, 200, 900, 100],
      items: [
        { icon: 'folder', iconClass: 'blue white--text', title: 'Reports', subtitle: 'Jan 9, 2014' },
        { icon: 'folder', iconClass: 'blue white--text', title: 'Allocations', subtitle: 'Jan 17, 2014' },
        { icon: 'folder', iconClass: 'amber white--text', title: 'Client On-boarding', subtitle: 'Jan 28, 2014' },
        { icon: 'folder', iconClass: 'blue white--text', title: 'Maintenance', subtitle: 'Jan 17, 2014' },
      ],
      interval: {},
      value_3: 0,
    }
  },

  computed: {
    ...mapGetters([
      "allApplicationDefaults",
      "allCurrencies",
      "allCounterparties",
      "currentSystemDate",
    ]),

    currentUser() {
      return this.$store.state.auth.user;
    },

    Currency() {
      return this.allCurrencies.filter(a => a.CurrencyID == this.CurrencyId && a.CheckerID != 0 && a.RejectionID == 0);
    },
  },

  watch: {
    'Sellers': {
      handler: function(newValue, oldValue) {
        if(newValue.length > oldValue.length){
          this.value = newValue
          this.value_1 = oldValue
          if(this.Sellers.length > 5){
            this.Sellers.pop()
          } else {
            this.getMMRates(newValue[oldValue.length], oldValue.length)
          }
        } else {
          for(let i = 0; i < oldValue.length; i++){
            if(newValue[i] != oldValue[i]){
              this.MMRates.splice(i, 1)
              break
            }
          }
        }
      },
      deep: true
    },
  },

  created(){
    this.CurrencyId = this.allApplicationDefaults[0].CurrencyID;
    this.GetGraphs();
  },

  methods: {
    async GetGraphs(){
      this.message = '';
      this.loading = true;
      var data ={
        CurrencyID: this.CurrencyId,
      }
      await reportsService.getAssetDistributionGraph(data)
      .then(response => {
        const { Cash, Equity, Bond, Property, MoneyMarket } = response.data.data[0]
        this.AssetDistributionTotal = Number(Cash) + Number(Equity) + Number(Bond) + Number(Property) + Number(MoneyMarket)
        this.AssetDistributionGraph = [Number(Cash), Number(Equity), Number(Bond), Number(Property), Number(MoneyMarket)]
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })

      await reportsService.getAssetPerformanceGraph(data)
      .then(response => {
        var temp = []
        for(let i = 0; i < this.AssetPerformanceLabels.length; i++){
          temp.push(response.data.data.map(r => Number(r[`${this.AssetPerformanceLabels[i]}`])))
        }
        var datasets = [];
        for(let i = 0; i < this.AssetPerformanceLabels.length; i++){
          datasets.push({label: this.AssetPerformanceLabels[i], data: temp[i], backgroundColor: this.backgroundColor[i]})
        }
        this.AssetPerformanceGraph = datasets;
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })

      await reportsService.getFUMTopFiveGraph(data)
      .then(response => {
        var datasets = [];
        for(let i = 0; i < response.data.data.length; i++){
          datasets.push({label: response.data.data[i].ClientName.substring(0, 15), data: [Number(response.data.data[i].TotalValue)], backgroundColor: this.backgroundColor[i]})
        }
        this.FUMTopFiveGraph = datasets
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })

      this.loading = false
    },

    getMMRates(ID, index){
      this.message = '';
      this.loading = true;

      var data = {
        SellerID: ID,
        CurrencyID: this.CurrencyId,
        StartDate: this.currentSystemDate.DayDate,
        EndDate: this.currentSystemDate.DayDate
      }

      reportsService.getMMRatesGraph(data)
      .then(response => {
        if(response.data.data.length == 0){
          this.MMRates.push({label: 'Empty Record', data: [], fill: false, tension: 0, borderColor: this.backgroundColor[index]})
        } else {
          var dataset = [];
          for(let j = 0; j < this.MMRatesLabels.length; j++){
            dataset.push(Number(response.data.data[0][`${this.MMRatesLabels[j]}`]))
          }

          this.MMRates.push({label: response.data.data[0].Seller, data: dataset, fill: false, tension: 0, borderColor: this.backgroundColor[index]})
        }
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })

      this.loading = false
    },

    dataFormat: function(a, b) {
      if(b) return ((b/this.AssetDistributionTotal)*100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) + "%";
      return a;
    },

    mapCurrency(currency) {
      return this.CurrencyId = currency.CurrencyID
    },
  },

  mounted () {
    // UserService.getUserBoard().then(
    //   response => {
    //     this.content = response.data;
    //     console.log(response.data);
    //   },
    //   error => {
    //     this.content =
    //       (error.response && error.response.data) ||
    //       error.message ||
    //       error.toString();
    //   }
    // );
    this.interval = setInterval(() => {
      if (this.value_3 === 100) {
        return (this.value_3 = 0)
      }
      this.value_3 += 10
    }, 1000)
  }
}
</script>

<style scoped>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.v-btn {
  outline: none
}

.v-sheet--offset {
  top: -24px;
  position: relative;
}

.board{
  background-color: white
};

</style>
